export default "__VITE_PUBLIC_ASSET__e2dd6c65__"